// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import "./SalarySlipForm.css";
// import { numberToWords } from "../utils/numberToWords";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
// import {
//   Box,
//   Typography,
//   Paper,
//   Grid,
//   Button,
//   TextField,
//   MenuItem,
//   Select,
//   FormControl,
//   InputLabel,
//   Card,
//   CardContent,
// } from "@mui/material";
// import Layout from "../Layout";
// import {
//   Search as SearchIcon,
//   Download as DownloadIcon,
// } from "@mui/icons-material";

// const BASE_URL = process.env.REACT_APP_BASE_URL;

// const SalarySlipForm = () => {
//   const [employeeid, setEmployeeid] = useState("");
//   const [month, setMonth] = useState("");
//   const [year, setYear] = useState("");
//   const [salarySlip, setSalarySlip] = useState(null);
//   const [error, setError] = useState("");
//   const [employees, setEmployees] = useState([]);
//   const [filteredEmployees, setFilteredEmployees] = useState([]);
//   const [search, setSearch] = useState("");
//   const [selectedEmployee, setSelectedEmployee] = useState(null);

//   const months = [
//     { value: "1", label: "January" },
//     { value: "2", label: "February" },
//     { value: "3", label: "March" },
//     { value: "4", label: "April" },
//     { value: "5", label: "May" },
//     { value: "6", label: "June" },
//     { value: "7", label: "July" },
//     { value: "8", label: "August" },
//     { value: "9", label: "September" },
//     { value: "10", label: "October" },
//     { value: "11", label: "November" },
//     { value: "12", label: "December" },
//   ];

//   const currentYear = new Date().getFullYear();
//   const currentMonth = new Date().getMonth() + 1; // Months are 0-indexed in JS
//   const years = Array.from({ length: 10 }, (_, i) => currentYear - i);

//   useEffect(() => {
//     const fetchEmployees = async () => {
//       try {
//         const token = sessionStorage.getItem("token");
//         const response = await axios.get(`${BASE_URL}/api/employees`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });

//         setEmployees(response.data);
//       } catch (err) {
//         console.error("Error fetching employees:", err);
//         setError("Unable to fetch employees");
//       }
//     };

//     fetchEmployees();
//   }, []);

//   const handleSearchChange = (e) => {
//     const query = e.target.value;
//     setSearch(query);
//     const filtered = employees.filter(
//       (emp) =>
//         emp.name.toLowerCase().includes(query.toLowerCase()) ||
//         emp.employeeid.toString().includes(query)
//     );
//     setFilteredEmployees(filtered);
//   };

//   const handleSelectEmployee = (employeeId, employeeName, dateOfJoining) => {
//     setSearch(`${employeeName} (${employeeId})`);
//     setEmployeeid(employeeId);
//     setSelectedEmployee({
//       id: employeeId,
//       name: employeeName,
//       dateOfJoining: new Date(dateOfJoining),
//     });
//     setFilteredEmployees([]);
//     setMonth("");
//     setYear("");
//   };

//   const isFutureMonth = (selectedMonth, selectedYear) => {
//     if (selectedYear > currentYear) return true;
//     if (selectedYear === currentYear && selectedMonth > currentMonth)
//       return true;
//     return false;
//   };

//   const isBeforeJoiningDate = (selectedMonth, selectedYear, joiningDate) => {
//     if (!joiningDate) return false;

//     const joiningYear = joiningDate.getFullYear();
//     const joiningMonth = joiningDate.getMonth() + 1; // Months are 0-indexed in JS Date

//     if (selectedYear < joiningYear) return true;
//     if (selectedYear === joiningYear && selectedMonth < joiningMonth)
//       return true;
//     return false;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!employeeid || !month || !year) {
//       setError("Please fill all required fields");
//       return;
//     }

//     const selectedMonthNum = parseInt(month, 10);
//     const selectedYearNum = parseInt(year, 10);

//     // Check if selected month/year is in the future
//     if (isFutureMonth(selectedMonthNum, selectedYearNum)) {
//       setError("Cannot generate salary slip for future months");
//       return;
//     }

//     // Check if selected month/year is before employee's joining date
//     if (
//       selectedEmployee &&
//       selectedEmployee.dateOfJoining &&
//       isBeforeJoiningDate(
//         selectedMonthNum,
//         selectedYearNum,
//         selectedEmployee.dateOfJoining
//       )
//     ) {
//       setError(
//         `Cannot generate salary slip before employee's joining date (${selectedEmployee.dateOfJoining.toLocaleDateString()})`
//       );
//       return;
//     }

//     try {
//       const token = sessionStorage.getItem("token");
//       const response = await axios.post(
//         `${BASE_URL}/api/salaryslip/generate`,
//         { employeeid, month, year },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       setSalarySlip(response.data);
//       setError("");
//     } catch (err) {
//       console.error("Error fetching salary slip:", err);
//       setError(
//         err.response?.data?.message ||
//           "Error generating salary slip. Please check the details and try again."
//       );
//       setSalarySlip(null);
//     }
//   };


//     const downloadPDF = async () => {
//       const doc = new jsPDF();
  
//       // Load the logo image
//       const logoUrl = require("../../Assets/brandBlack.png"); // Adjust path as needed
//       const logoResponse = await fetch(logoUrl);
//       const logoBlob = await logoResponse.blob();
//       const logoDataUrl = await new Promise((resolve) => {
//         const reader = new FileReader();
//         reader.onload = () => resolve(reader.result);
//         reader.readAsDataURL(logoBlob);
//       });
  
//       // Add logo to the top right
//       doc.addImage(logoDataUrl, "PNG", 150, 10, 40, 20);
  
//       // Company Header
//       doc.setFontSize(14);
//       doc.setTextColor(0, 0, 0);
//       doc.setFont("helvetica", "bold");
//       doc.text("InfyU Labs Pvt. Ltd.", 105, 15, null, null, "center");
  
//       doc.setFontSize(10);
//       doc.setFont("helvetica", "normal");
//       doc.text("CIN:U930 00DL2019PTC354588", 105, 22, null, null, "center");
//       doc.text(
//         "Reg Add - H N. 28, Kh. No. 38/1, 1st Floor,",
//         105,
//         28,
//         null,
//         null,
//         "center"
//       );
//       doc.text(
//         "Amrit Vihar, BLK-A, Burari, North",
//         105,
//         34,
//         null,
//         null,
//         "center"
//       );
//       doc.text("Delhi 110084 IN", 105, 40, null, null, "center");
  
//       // Horizontal line
//       doc.setDrawColor(0, 0, 0);
//       doc.line(15, 45, 195, 45);
  
//       // Operational Office Address
//       doc.setFont("helvetica", "bold");
//       doc.text("INFYU LABS PRIVATE LIMITED", 105, 52, null, null, "center");
//       doc.setFont("helvetica", "normal");
//       doc.text(
//         "Operational Office Address - InfyU Labs, C01 and C05, #402, Research Park,",
//         105,
//         58,
//         null,
//         null,
//         "center"
//       );
//       doc.text(
//         "IIT Gandhinagar, Palaj, Gandhinagar, Gujarat, 382355",
//         105,
//         64,
//         null,
//         null,
//         "center"
//       );
  
//       // Another horizontal line
//       doc.line(15, 70, 195, 70);
  
//       // Pay Slip Title
//       doc.setFontSize(12);
//       doc.setFont("helvetica", "bold");
//       doc.text(`Pay Slip for the month of`, 105, 80, null, null, "center");
//       doc.text(
//         `${salarySlip.month} ${salarySlip.year}`,
//         105,
//         86,
//         null,
//         null,
//         "center"
//       );
  
//       // Employee Details Table - Adjusted to match width of Salary Details Table
//       doc.autoTable({
//         startY: 95,
//         margin: { left: 25 }, // Changed from 15 to 25 to match the second table
//         styles: { fontSize: 10, cellPadding: 3 },
//         columnStyles: {
//           0: { cellWidth: 45, fontStyle: "bold" },
//           1: { cellWidth: 30 },
//           2: { cellWidth: 45, fontStyle: "bold" },
//           3: { cellWidth: 45 },
//         },
//         body: [
//           [
//             "Emp ID",
//             salarySlip.employeeId,
//             "Employee Name:-",
//             salarySlip.employeeName,
//           ],
//           ["PF. No.", "NA", "DOJ : -", salarySlip.dateOfJoining],
//           ["Paid / Present Days", salarySlip.fullDays, "", ""],
//           ["Location", salarySlip.jobLocation, "", ""],
//         ],
//       });
  
//       // Salary Details Table - Width matches Employee Details Table
//       doc.autoTable({
//         startY: doc.autoTable.previous.finalY + 10,
//         margin: { left: 25 },
//         styles: { fontSize: 10, cellPadding: 3 },
//         columnStyles: {
//           0: { cellWidth: 45, fontStyle: "bold" },
//           1: { cellWidth: 30 },
//           2: { cellWidth: 45 },
//           3: { cellWidth: 45, fontStyle: "bold" },
//         },
//         head: [["Earnings", "Rate", "Earned Salary", "Deductions"]],
//         body: [
//           ["BASIC", "", salarySlip.basic, "TDS"],
//           ["HRA", "", salarySlip.hra, salarySlip.TDSAmount],
//           ["Special All", "", salarySlip.special, ""],
//           ["Total", "", salarySlip.netPayableSalary, "Total"],
//           ["Net Pay", "", salarySlip.netPayableSalary, "0"],
//           ["In Words", { content: formattedSalaryInWords, colSpan: 3 }, "", ""],
//         ],
//       });
  
//       // Footer note
//       doc.setFontSize(8);
//       doc.setFont("helvetica", "italic");
//       doc.text(
//         "* This is a computer generated salary-slip which does not require any signature.",
//         105,
//         doc.autoTable.previous.finalY + 10,
//         null,
//         null,
//         "center"
//       );
  
//       doc.save(
//         `SalarySlip_${salarySlip.employeeId}_${salarySlip.month}_${salarySlip.year}.pdf`
//       );
//     };


//   const formattedSalaryInWords = salarySlip?.netPayableSalary
//     ? numberToWords(Number(salarySlip.netPayableSalary))
//     : "Salary not available";

//   return (
//     <Layout>
//       <Box
//         sx={{
//           p: 3,
//         }}
//       >
//         <Typography
//           variant="h4"
//           component="h1"
//           gutterBottom
//           sx={{ fontWeight: "bold", color: "primary.main", mb: 4 }}
//         >
//           Salary Slip Generator
//         </Typography>

//         <Grid container spacing={3} justifyContent="center">
//           <Grid item xs={12} md={8} lg={6}>
//             <Paper elevation={3} sx={{ p: 3 }}>
//               <Typography
//                 variant="h6"
//                 component="h2"
//                 gutterBottom
//                 sx={{ mb: 3, textAlign: "center" }}
//               >
//                 Generate Salary Slip
//               </Typography>

//               <form onSubmit={handleSubmit}>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12}>
//                     <FormControl fullWidth>
//                       <TextField
//                         label="Search Employee"
//                         variant="outlined"
//                         value={search}
//                         onChange={handleSearchChange}
//                         InputProps={{
//                           startAdornment: (
//                             <SearchIcon color="action" sx={{ mr: 1 }} />
//                           ),
//                         }}
//                         fullWidth
//                       />
//                       {search && filteredEmployees.length > 0 && (
//                         <Paper sx={{ mt: 1, maxHeight: 200, overflow: "auto" }}>
//                           {filteredEmployees.map((emp) => (
//                             <MenuItem
//                               key={emp.employeeid}
//                               onClick={() =>
//                                 handleSelectEmployee(
//                                   emp.employeeid,
//                                   emp.name,
//                                   emp.dateOfJoining
//                                 )
//                               }
//                               sx={{ py: 1, px: 2 }}
//                             >
//                               <Typography variant="body2">
//                                 <strong>{emp.name}</strong> (ID:{" "}
//                                 {emp.employeeid}) - Joined: {emp.dateOfJoining}
//                               </Typography>
//                             </MenuItem>
//                           ))}
//                         </Paper>
//                       )}
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} sm={6}>
//                     <FormControl fullWidth>
//                       <InputLabel id="month-label">Month</InputLabel>
//                       <Select
//                         labelId="month-label"
//                         id="month"
//                         value={month}
//                         onChange={(e) => setMonth(e.target.value)}
//                         label="Month"
//                         required
//                       >
//                         <MenuItem value="">
//                           <em>Select Month</em>
//                         </MenuItem>
//                         {months.map((m) => {
//                           const monthNum = parseInt(m.value, 10);
//                           const yearNum = year
//                             ? parseInt(year, 10)
//                             : currentYear;

//                           // Disable future months
//                           const isFuture = isFutureMonth(monthNum, yearNum);

//                           // Disable months before joining date if employee is selected
//                           let isBeforeJoining = false;
//                           if (
//                             selectedEmployee &&
//                             selectedEmployee.dateOfJoining
//                           ) {
//                             isBeforeJoining = isBeforeJoiningDate(
//                               monthNum,
//                               yearNum,
//                               selectedEmployee.dateOfJoining
//                             );
//                           }

//                           return (
//                             <MenuItem
//                               key={m.value}
//                               value={m.value}
//                               disabled={isFuture || isBeforeJoining}
//                             >
//                               {m.label}
//                               {(isFuture || isBeforeJoining) &&
//                                 " (Not available)"}
//                             </MenuItem>
//                           );
//                         })}
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} sm={6}>
//                     <FormControl fullWidth>
//                       <InputLabel id="year-label">Year</InputLabel>
//                       <Select
//                         labelId="year-label"
//                         id="year"
//                         value={year}
//                         onChange={(e) => {
//                           setYear(e.target.value);
//                           // Reset month when year changes to prevent invalid combinations
//                           setMonth("");
//                         }}
//                         label="Year"
//                         required
//                       >
//                         <MenuItem value="">
//                           <em>Select Year</em>
//                         </MenuItem>
//                         {years.map((y) => {
//                           const yearNum = parseInt(y, 10);
//                           let isFuture = yearNum > currentYear;
//                           let isBeforeJoining = false;

//                           if (
//                             selectedEmployee &&
//                             selectedEmployee.dateOfJoining
//                           ) {
//                             isBeforeJoining =
//                               yearNum <
//                               selectedEmployee.dateOfJoining.getFullYear();
//                           }

//                           return (
//                             <MenuItem
//                               key={y}
//                               value={y}
//                               disabled={isFuture || isBeforeJoining}
//                             >
//                               {y}
//                               {(isFuture || isBeforeJoining) &&
//                                 " (Not available)"}
//                             </MenuItem>
//                           );
//                         })}
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12}>
//                     <Button
//                       type="submit"
//                       variant="contained"
//                       color="primary"
//                       fullWidth
//                       size="large"
//                       sx={{ mt: 2 }}
//                     >
//                       Generate Salary Slip
//                     </Button>
//                   </Grid>
//                 </Grid>
//               </form>

//               {error && (
//                 <Typography color="error" sx={{ mt: 2 }}>
//                   {error}
//                 </Typography>
//               )}
//             </Paper>
//           </Grid>

//           {salarySlip && (
//             <Grid item xs={12} md={6}>
//               <Card elevation={3}>
//                 <CardContent>
//                   <Box
//                     sx={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "center",
//                       mb: 2,
//                     }}
//                   >
//                     <Typography variant="h6" component="h2">
//                       Salary Slip Details
//                     </Typography>
//                     <Button
//                       variant="outlined"
//                       startIcon={<DownloadIcon />}
//                       onClick={downloadPDF}
//                       sx={{ textTransform: "none" }}
//                     >
//                       Download PDF
//                     </Button>
//                   </Box>

//                   <Grid container spacing={2}>
//                     <Grid item xs={12} sm={6}>
//                       <Typography variant="body2">
//                         <strong>Employee Name:</strong>{" "}
//                         {salarySlip.employeeName}
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <Typography variant="body2">
//                         <strong>Employee ID:</strong> {salarySlip.employeeId}
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <Typography variant="body2">
//                         <strong>Designation:</strong> {salarySlip.designation}
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <Typography variant="body2">
//                         <strong>Period:</strong> {salarySlip.month}{" "}
//                         {salarySlip.year}
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <Typography variant="body2">
//                         <strong>Date of Joining:</strong>{" "}
//                         {salarySlip.dateOfJoining}
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <Typography variant="body2">
//                         <strong>Job Location:</strong> {salarySlip.jobLocation}
//                       </Typography>
//                     </Grid>

//                     <Grid item xs={12} sx={{ mt: 2 }}>
//                       <Typography
//                         variant="subtitle2"
//                         sx={{ fontWeight: "bold" }}
//                       >
//                         Attendance Summary
//                       </Typography>
//                       <Grid container spacing={1} sx={{ mt: 1 }}>
//                         <Grid item xs={4}>
//                           <Typography variant="body2">
//                             <strong>Total Days:</strong>{" "}
//                             {salarySlip.totalDaysInMonth}
//                           </Typography>
//                         </Grid>
//                         <Grid item xs={4}>
//                           <Typography variant="body2">
//                             <strong>Full Days:</strong> {salarySlip.fullDays}
//                           </Typography>
//                         </Grid>
//                         <Grid item xs={4}>
//                           <Typography variant="body2">
//                             <strong>Half Days:</strong> {salarySlip.halfDays}
//                           </Typography>
//                         </Grid>
//                         <Grid item xs={4}>
//                           <Typography variant="body2">
//                             <strong>Absent Days:</strong>{" "}
//                             {salarySlip.absentDays}
//                           </Typography>
//                         </Grid>
//                       </Grid>
//                     </Grid>

//                     <Grid item xs={12} sx={{ mt: 2 }}>
//                       <Typography
//                         variant="subtitle2"
//                         sx={{ fontWeight: "bold" }}
//                       >
//                         Earnings
//                       </Typography>
//                       <Grid container spacing={1} sx={{ mt: 1 }}>
//                         <Grid item xs={6}>
//                           <Typography variant="body2">
//                             <strong>Basic:</strong> {salarySlip.basic}
//                           </Typography>
//                         </Grid>
//                         <Grid item xs={6}>
//                           <Typography variant="body2">
//                             <strong>HRA:</strong> {salarySlip.hra}
//                           </Typography>
//                         </Grid>
//                         <Grid item xs={6}>
//                           <Typography variant="body2">
//                             <strong>Special Allowance:</strong>{" "}
//                             {salarySlip.special}
//                           </Typography>
//                         </Grid>
//                       </Grid>
//                     </Grid>

//                     <Grid item xs={12} sx={{ mt: 2 }}>
//                       <Typography
//                         variant="subtitle2"
//                         sx={{ fontWeight: "bold" }}
//                       >
//                         Deductions
//                       </Typography>
//                       <Grid container spacing={1} sx={{ mt: 1 }}>
//                         <Grid item xs={6}>
//                           <Typography variant="body2">
//                             <strong>TDS:</strong> {salarySlip.TDSAmount}
//                           </Typography>
//                         </Grid>
//                         <Grid item xs={6}>
//                           <Typography variant="body2">
//                             <strong>Leave Deduction:</strong>{" "}
//                             {salarySlip.leavededuction}
//                           </Typography>
//                         </Grid>
//                       </Grid>
//                     </Grid>

//                     <Grid item xs={12} sx={{ mt: 3 }}>
//                       <Paper
//                         elevation={1}
//                         sx={{ p: 2, backgroundColor: "#f5f5f5" }}
//                       >
//                         <Grid container>
//                           <Grid item xs={6}>
//                             <Typography
//                               variant="subtitle1"
//                               sx={{ fontWeight: "bold" }}
//                             >
//                               Net Payable Salary:
//                             </Typography>
//                           </Grid>
//                           <Grid item xs={6} sx={{ textAlign: "right" }}>
//                             <Typography
//                               variant="subtitle1"
//                               sx={{ fontWeight: "bold" }}
//                             >
//                               {salarySlip.netPayableSalary}
//                             </Typography>
//                           </Grid>
//                           <Grid item xs={12}>
//                             <Typography
//                               variant="body2"
//                               sx={{ fontStyle: "italic" }}
//                             >
//                               {formattedSalaryInWords}
//                             </Typography>
//                           </Grid>
//                         </Grid>
//                       </Paper>
//                     </Grid>
//                   </Grid>
//                 </CardContent>
//               </Card>
//             </Grid>
//           )}
//         </Grid>
//       </Box>
//     </Layout>
//   );
// };

// export default SalarySlipForm;





















import React, { useState, useEffect } from "react";
import axios from "axios";
import "./SalarySlipForm.css";
import { numberToWords } from "../utils/numberToWords";
import jsPDF from "jspdf";
import "jspdf-autotable";
import {
  Box,
  Typography,
  Paper,
  Grid,
  Button,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Card,
  CardContent,
  Divider,
  CircularProgress,
  Alert,
  IconButton,
} from "@mui/material";
import Layout from "../Layout";
import {
  Search as SearchIcon,
  Download as DownloadIcon,
  Person as PersonIcon,
  Badge as BadgeIcon,
  Work as WorkIcon,
  CalendarToday as CalendarTodayIcon,
  LocationOn as LocationOnIcon,
  AttachMoney as AttachMoneyIcon,
  EventAvailable as EventAvailableIcon,
  Archive as ArchiveIcon,
  MonetizationOn as MonetizationOnIcon,
} from "@mui/icons-material";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const SalarySlipForm = () => {
  const [employeeid, setEmployeeid] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [salarySlip, setSalarySlip] = useState(null);
  const [error, setError] = useState("");
  const [employees, setEmployees] = useState([]);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const months = [
    { value: "1", label: "January" },
    { value: "2", label: "February" },
    { value: "3", label: "March" },
    { value: "4", label: "April" },
    { value: "5", label: "May" },
    { value: "6", label: "June" },
    { value: "7", label: "July" },
    { value: "8", label: "August" },
    { value: "9", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;
  const years = Array.from({ length: 10 }, (_, i) => currentYear - i);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const token = sessionStorage.getItem("token");
        const response = await axios.get(`${BASE_URL}/api/employees`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setEmployees(response.data);
      } catch (err) {
        console.error("Error fetching employees:", err);
        setError("Unable to fetch employees");
      }
    };
    fetchEmployees();
  }, []);

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearch(query);
    const filtered = employees.filter(
      (emp) =>
        emp.name.toLowerCase().includes(query.toLowerCase()) ||
        emp.employeeid.toString().includes(query)
    );
    setFilteredEmployees(filtered);
  };

  const handleSelectEmployee = (employeeId, employeeName, dateOfJoining) => {
    setSearch(`${employeeName} (${employeeId})`);
    setEmployeeid(employeeId);
    setSelectedEmployee({
      id: employeeId,
      name: employeeName,
      dateOfJoining: new Date(dateOfJoining),
    });
    setFilteredEmployees([]);
    setMonth("");
    setYear("");
  };

  const isFutureMonth = (selectedMonth, selectedYear) => {
    if (selectedYear > currentYear) return true;
    if (selectedYear === currentYear && selectedMonth > currentMonth) return true;
    return false;
  };

  const isBeforeJoiningDate = (selectedMonth, selectedYear, joiningDate) => {
    if (!joiningDate) return false;
    const joiningYear = joiningDate.getFullYear();
    const joiningMonth = joiningDate.getMonth() + 1;
    if (selectedYear < joiningYear) return true;
    if (selectedYear === joiningYear && selectedMonth < joiningMonth) return true;
    return false;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!employeeid || !month || !year) {
      setError("Please fill all required fields");
      return;
    }

    const selectedMonthNum = parseInt(month, 10);
    const selectedYearNum = parseInt(year, 10);

    if (isFutureMonth(selectedMonthNum, selectedYearNum)) {
      setError("Cannot generate salary slip for future months");
      return;
    }

    if (
      selectedEmployee &&
      selectedEmployee.dateOfJoining &&
      isBeforeJoiningDate(
        selectedMonthNum,
        selectedYearNum,
        selectedEmployee.dateOfJoining
      )
    ) {
      setError(
        `Cannot generate salary slip before employee's joining date (${selectedEmployee.dateOfJoining.toLocaleDateString()})`
      );
      return;
    }

    setIsLoading(true);
    try {
      const token = sessionStorage.getItem("token");
      const response = await axios.post(
        `${BASE_URL}/api/salaryslip/generate`,
        { employeeid, month, year },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSalarySlip(response.data);
      setError("");
    } catch (err) {
      console.error("Error fetching salary slip:", err);
      setError(
        err.response?.data?.message ||
          "Error generating salary slip. Please check the details and try again."
      );
      setSalarySlip(null);
    } finally {
      setIsLoading(false);
    }
  };

  const downloadPDF = async () => {
    const doc = new jsPDF();
    const logoUrl = require("../../Assets/brandBlack.png");
    const logoResponse = await fetch(logoUrl);
    const logoBlob = await logoResponse.blob();
    const logoDataUrl = await new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.readAsDataURL(logoBlob);
    });

    doc.addImage(logoDataUrl, "PNG", 150, 10, 40, 20);
    doc.setFontSize(14);
    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "bold");
    doc.text("InfyU Labs Pvt. Ltd.", 105, 15, null, null, "center");
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text("CIN:U930 00DL2019PTC354588", 105, 22, null, null, "center");
    doc.text(
      "Reg Add - H N. 28, Kh. No. 38/1, 1st Floor,",
      105,
      28,
      null,
      null,
      "center"
    );
    doc.text(
      "Amrit Vihar, BLK-A, Burari, North",
      105,
      34,
      null,
      null,
      "center"
    );
    doc.text("Delhi 110084 IN", 105, 40, null, null, "center");
    doc.setDrawColor(0, 0, 0);
    doc.line(15, 45, 195, 45);
    doc.setFont("helvetica", "bold");
    doc.text("INFYU LABS PRIVATE LIMITED", 105, 52, null, null, "center");
    doc.setFont("helvetica", "normal");
    doc.text(
      "Operational Office Address - InfyU Labs, C01 and C05, #402, Research Park,",
      105,
      58,
      null,
      null,
      "center"
    );
    doc.text(
      "IIT Gandhinagar, Palaj, Gandhinagar, Gujarat, 382355",
      105,
      64,
      null,
      null,
      "center"
    );
    doc.line(15, 70, 195, 70);
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(`Pay Slip for the month of`, 105, 80, null, null, "center");
    doc.text(
      `${salarySlip.month} ${salarySlip.year}`,
      105,
      86,
      null,
      null,
      "center"
    );

    doc.autoTable({
      startY: 95,
      margin: { left: 25 },
      styles: { fontSize: 10, cellPadding: 3 },
      columnStyles: {
        0: { cellWidth: 45, fontStyle: "bold" },
        1: { cellWidth: 30 },
        2: { cellWidth: 45, fontStyle: "bold" },
        3: { cellWidth: 45 },
      },
      body: [
        [
          "Emp ID",
          salarySlip.employeeId,
          "Employee Name:-",
          salarySlip.employeeName,
        ],
        ["PF. No.", "NA", "DOJ : -", salarySlip.dateOfJoining],
        ["Paid / Present Days", salarySlip.fullDays, "", ""],
        ["Location", salarySlip.jobLocation, "", ""],
      ],
    });

    doc.autoTable({
      startY: doc.autoTable.previous.finalY + 10,
      margin: { left: 25 },
      styles: { fontSize: 10, cellPadding: 3 },
      columnStyles: {
        0: { cellWidth: 45, fontStyle: "bold" },
        1: { cellWidth: 30 },
        2: { cellWidth: 45 },
        3: { cellWidth: 45, fontStyle: "bold" },
      },
      head: [["Earnings", "Rate", "Earned Salary", "Deductions"]],
      body: [
        ["BASIC", "", salarySlip.basic, "TDS"],
        ["HRA", "", salarySlip.hra, salarySlip.TDSAmount],
        ["Special All", "", salarySlip.special, ""],
        ["Total", "", salarySlip.netPayableSalary, "Total"],
        ["Net Pay", "", salarySlip.netPayableSalary, "0"],
        ["In Words", { content: formattedSalaryInWords, colSpan: 3 }, "", ""],
      ],
    });

    doc.setFontSize(8);
    doc.setFont("helvetica", "italic");
    doc.text(
      "* This is a computer generated salary-slip which does not require any signature.",
      105,
      doc.autoTable.previous.finalY + 10,
      null,
      null,
      "center"
    );

    doc.save(
      `SalarySlip_${salarySlip.employeeId}_${salarySlip.month}_${salarySlip.year}.pdf`
    );
  };

  const formattedSalaryInWords = salarySlip?.netPayableSalary
    ? numberToWords(Number(salarySlip.netPayableSalary))
    : "Salary not available";

  return (
    <Layout>
      <Box sx={{ p: 3 }}>
        <Typography
          variant="h4"
          component="h1"
          gutterBottom
          sx={{ fontWeight: "bold", color: "primary.main", mb: 4 , mt:5  }}
        >
          Salary Slip Generator
        </Typography>

        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} md={8} lg={6}>
            <Paper elevation={3} sx={{ p: 3 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1,
                  mb: 2,
                }}
              >
                <AttachMoneyIcon color="primary" />
                <Typography variant="h6" component="h2" gutterBottom>
                  Generate Salary Slip
                </Typography>
              </Box>

              <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <TextField
                        label="Search Employee"
                        variant="outlined"
                        value={search}
                        onChange={handleSearchChange}
                        InputProps={{
                          startAdornment: (
                            <SearchIcon color="action" sx={{ mr: 1 }} />
                          ),
                        }}
                        fullWidth
                      />
                      {search && filteredEmployees.length > 0 && (
                        <Paper sx={{ mt: 1, maxHeight: 200, overflow: "auto" }}>
                          {filteredEmployees.map((emp) => (
                            <MenuItem
                              key={emp.employeeid}
                              onClick={() =>
                                handleSelectEmployee(
                                  emp.employeeid,
                                  emp.name,
                                  emp.dateOfJoining
                                )
                              }
                              sx={{ py: 1, px: 2 }}
                            >
                              <Typography variant="body2">
                                <strong>{emp.name}</strong> (ID:{" "}
                                {emp.employeeid}) - Joined: {emp.dateOfJoining}
                              </Typography>
                            </MenuItem>
                          ))}
                        </Paper>
                      )}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <InputLabel id="month-label">Month</InputLabel>
                      <Select
                        labelId="month-label"
                        id="month"
                        value={month}
                        onChange={(e) => setMonth(e.target.value)}
                        label="Month"
                        required
                      >
                        <MenuItem value="">
                          <em>Select Month</em>
                        </MenuItem>
                        {months.map((m) => {
                          const monthNum = parseInt(m.value, 10);
                          const yearNum = year
                            ? parseInt(year, 10)
                            : currentYear;
                          const isFuture = isFutureMonth(monthNum, yearNum);
                          let isBeforeJoining = false;
                          if (
                            selectedEmployee &&
                            selectedEmployee.dateOfJoining
                          ) {
                            isBeforeJoining = isBeforeJoiningDate(
                              monthNum,
                              yearNum,
                              selectedEmployee.dateOfJoining
                            );
                          }

                          return (
                            <MenuItem
                              key={m.value}
                              value={m.value}
                              disabled={isFuture || isBeforeJoining}
                            >
                              {m.label}
                              {(isFuture || isBeforeJoining) &&
                                " (Not available)"}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <InputLabel id="year-label">Year</InputLabel>
                      <Select
                        labelId="year-label"
                        id="year"
                        value={year}
                        onChange={(e) => {
                          setYear(e.target.value);
                          setMonth("");
                        }}
                        label="Year"
                        required
                      >
                        <MenuItem value="">
                          <em>Select Year</em>
                        </MenuItem>
                        {years.map((y) => {
                          const yearNum = parseInt(y, 10);
                          let isFuture = yearNum > currentYear;
                          let isBeforeJoining = false;

                          if (
                            selectedEmployee &&
                            selectedEmployee.dateOfJoining
                          ) {
                            isBeforeJoining =
                              yearNum <
                              selectedEmployee.dateOfJoining.getFullYear();
                          }

                          return (
                            <MenuItem
                              key={y}
                              value={y}
                              disabled={isFuture || isBeforeJoining}
                            >
                              {y}
                              {(isFuture || isBeforeJoining) &&
                                " (Not available)"}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      fullWidth
                      size="large"
                      sx={{ mt: 2 }}
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <CircularProgress size={24} color="inherit" />
                      ) : (
                        "Generate Salary Slip"
                      )}
                    </Button>
                  </Grid>
                </Grid>
              </form>

              {error && (
                <Alert severity="error" sx={{ mt: 2 }}>
                  {error}
                </Alert>
              )}
            </Paper>
          </Grid>

          {salarySlip && (
            <Grid item xs={12} md={6}>
              <Card elevation={3}>
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 2,
                    }}
                  >
                    <Typography variant="h6" component="h2">
                      Salary Slip Details
                    </Typography>
                    <Button
                      variant="contained"
                      startIcon={<DownloadIcon />}
                      onClick={downloadPDF}
                      sx={{
                        textTransform: "none",
                        backgroundColor: "#1E40AF",
                        "&:hover": { backgroundColor: "#152D85" },
                      }}
                    >
                      Download PDF
                    </Button>
                  </Box>

                  <Grid container spacing={2}>
                    {/* Basic Info */}
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)" },
                          gap: 2,
                          mb: 2,
                        }}
                      >
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <PersonIcon color="primary" fontSize="small" />
                          <Box>
                            <Typography variant="body2" color="text.secondary">
                              Employee Name
                            </Typography>
                            <Typography variant="body1" fontWeight={500}>
                              {salarySlip.employeeName}
                            </Typography>
                          </Box>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <BadgeIcon color="primary" fontSize="small" />
                          <Box>
                            <Typography variant="body2" color="text.secondary">
                              Employee ID
                            </Typography>
                            <Typography variant="body1" fontWeight={500}>
                              {salarySlip.employeeId}
                            </Typography>
                          </Box>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <WorkIcon color="primary" fontSize="small" />
                          <Box>
                            <Typography variant="body2" color="text.secondary">
                              Designation
                            </Typography>
                            <Typography variant="body1" fontWeight={500}>
                              {salarySlip.designation}
                            </Typography>
                          </Box>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <CalendarTodayIcon color="primary" fontSize="small" />
                          <Box>
                            <Typography variant="body2" color="text.secondary">
                              Period
                            </Typography>
                            <Typography variant="body1" fontWeight={500}>
                              {salarySlip.month} {salarySlip.year}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </Grid>

                    {/* Attendance Summary */}
                    <Grid item xs={12}>
                      <Paper elevation={0} sx={{ p: 2, backgroundColor: "#f5f5f5" }}>
                        <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                          Attendance Summary
                        </Typography>
                        <Grid container spacing={1}>
                          <Grid item xs={6} sm={3}>
                            <Typography variant="body2">Total Days</Typography>
                            <Typography variant="body1" fontWeight={500}>
                              {salarySlip.totalDaysInMonth}
                            </Typography>
                          </Grid>
                          <Grid item xs={6} sm={3}>
                            <Typography variant="body2">Full Days</Typography>
                            <Typography variant="body1" fontWeight={500}>
                              {salarySlip.fullDays}
                            </Typography>
                          </Grid>
                          <Grid item xs={6} sm={3}>
                            <Typography variant="body2">Half Days</Typography>
                            <Typography variant="body1" fontWeight={500}>
                              {salarySlip.halfDays}
                            </Typography>
                          </Grid>
                          <Grid item xs={6} sm={3}>
                            <Typography variant="body2">Absent Days</Typography>
                            <Typography variant="body1" fontWeight={500}>
                              {salarySlip.absentDays}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Paper>
                    </Grid>

                    {/* Earnings */}
                    <Grid item xs={12}>
                      <Paper elevation={0} sx={{ p: 2, backgroundColor: "#e8f5e9" }}>
                        <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                          Earnings
                        </Typography>
                        <Box sx={{ mb: 1 }}>
                          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Typography variant="body2">Basic Salary</Typography>
                            <Typography variant="body1" fontWeight={500}>
                              {salarySlip.basic}
                            </Typography>
                          </Box>
                          <Divider sx={{ my: 1 }} />
                          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Typography variant="body2">HRA</Typography>
                            <Typography variant="body1" fontWeight={500}>
                              {salarySlip.hra}
                            </Typography>
                          </Box>
                          <Divider sx={{ my: 1 }} />
                          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Typography variant="body2">Special Allowance</Typography>
                            <Typography variant="body1" fontWeight={500}>
                              {salarySlip.special}
                            </Typography>
                          </Box>
                        </Box>
                        <Box
                          sx={{
                            mt: 2,
                            p: 2,
                            backgroundColor: "#c8e6c9",
                            borderRadius: 1,
                          }}
                        >
                          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Typography variant="body1" fontWeight={600}>
                              Gross Salary
                            </Typography>
                            <Typography variant="body1" fontWeight={600}>
                              {salarySlip.monthlySalary}
                            </Typography>
                          </Box>
                        </Box>
                      </Paper>
                    </Grid>

                    {/* Deductions */}
                    <Grid item xs={12}>
                      <Paper elevation={0} sx={{ p: 2, backgroundColor: "#ffebee" }}>
                        <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                          Deductions
                        </Typography>
                        <Box sx={{ mb: 1 }}>
                          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Typography variant="body2">TDS</Typography>
                            <Typography variant="body1" fontWeight={500}>
                              {salarySlip.TDSAmount}
                            </Typography>
                          </Box>
                          <Divider sx={{ my: 1 }} />
                          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Typography variant="body2">Leave Deduction</Typography>
                            <Typography variant="body1" fontWeight={500}>
                              {salarySlip.leavededuction}
                            </Typography>
                          </Box>
                        </Box>
                        <Box
                          sx={{
                            mt: 2,
                            p: 2,
                            backgroundColor: "#ffcdd2",
                            borderRadius: 1,
                          }}
                        >
                          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Typography variant="body1" fontWeight={600}>
                              Total Deductions
                            </Typography>
                            <Typography variant="body1" fontWeight={600}>
                              {salarySlip.TDSAmount + salarySlip.leavededuction}
                            </Typography>
                          </Box>
                        </Box>
                      </Paper>
                    </Grid>

                    {/* Net Salary */}
                    <Grid item xs={12}>
                      <Paper elevation={0} sx={{ p: 2, backgroundColor: "#e3f2fd" }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                          <Typography variant="subtitle1" fontWeight={600}>
                            Net Payable Salary
                          </Typography>
                          <Typography variant="subtitle1" fontWeight={600} color="primary">
                            {salarySlip.netPayableSalary}
                          </Typography>
                        </Box>
                        <Typography
                          variant="body2"
                          sx={{ fontStyle: "italic", color: "text.secondary", mt: 1 }}
                        >
                          {formattedSalaryInWords}
                        </Typography>
                      </Paper>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          )}
        </Grid>
      </Box>
    </Layout>
  );
};

export default SalarySlipForm;